import { createContext } from 'react';
import type { DialogSessionContextValue } from './types';

export const DialogSessionContext = createContext<DialogSessionContextValue | null>(null);
